export function changePasswordButton(btn) {
    const button = document.getElementById(btn);
    const tabContentId = document.getElementById('loginTab');

    function toggleContent(tab) {
        tab.checked = true;
    }

    button.addEventListener('click', function () {
        toggleContent(tabContentId);
    });
}